export const priceFormat = (value: number | undefined) => {
    if (value) {
        return (Intl.NumberFormat().format(value) + " ₽").replace(',', '.');
    }
}